const requestJson = (method, url, payload, csrfProtected = false) => new Promise((resolve, reject) => {
  const request = new XMLHttpRequest();

  request.open(method, url, true);
  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  request.setRequestHeader('Content-Type', 'application/json');
  if (csrfProtected) {
    const csrfToken = document.querySelector('meta[name="eccube-csrf-token"]')?.content;
    if (!csrfToken) {
      reject(new Error('CSRFトークンを取得できませんでした。'));
      return;
    }
    request.setRequestHeader('ECCUBE-CSRF-TOKEN', csrfToken);
  }

  request.onload = () => {
    let response = null;
    if (request.responseText !== '') {
      try {
        response = JSON.parse(request.responseText);
      } catch {
        reject(new Error('レスポンスJSONを解析できませんでした。'));
        return;
      }
    }

    if (request.status < 200 || request.status >= 300) {
      const message = response?.status === 'NG' && typeof response.message === 'string'
        ? response.message
        : `HTTP ${request.status}: ${request.statusText}`;
      reject(new Error(message));
      return;
    }

    resolve(response);
  };

  request.onerror = () => {
    reject(new Error('通信エラーが発生しました。'));
  };

  request.send(payload === undefined ? null : JSON.stringify(payload));
});

export const fetchCandidates = async () => {
  const response = await requestJson('POST', '/api/oshi/matching/list');

  if (response === null || response.status !== 'OK' || !Array.isArray(response.result)) {
    throw new Error('候補取得APIのレスポンス形式が不正です。');
  }

  return response.result;
};

export const submitDecision = async (publicCustomerId, liked) => {
  const response = await requestJson(
    'POST',
    '/api/oshi/matching/decision',
    {publicCustomerId, liked},
    true,
  );

  if (response === null || response.status !== 'OK' || response.result === null
    || typeof response.result !== 'object'
    || !Object.hasOwn(response.result, 'notification')) {
    throw new Error('判定APIのレスポンス形式が不正です。');
  }

  return response.result.notification;
};
